import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export default function LetterFormStep({ fields, sections, onChange }) {
  const set = (key, value) => onChange({ ...sections, [key]: value });

  return (
    <div className="grid gap-4">
      {fields.map((field) => (
        <div key={field.key}>
          <Label className="text-stone-700">{field.label}</Label>
          {field.multiline ? (
            <Textarea
              className="mt-1 min-h-[100px] bg-white"
              value={sections?.[field.key] || ''}
              onChange={(e) => set(field.key, e.target.value)}
            />
          ) : (
            <Input
              className="mt-1 bg-white"
              value={sections?.[field.key] || ''}
              onChange={(e) => set(field.key, e.target.value)}
            />
          )}
        </div>
      ))}
    </div>
  );
}
